/* eslint-disable */
// @ts-nocheck
/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/no-unresolved */
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars, react/jsx-newline, react/jsx-no-bind, no-else-return */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define, no-lonely-if, no-nested-ternary, import/no-extraneous-dependencies */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals, no-plusplus, no-empty, consistent-return, react/no-array-index-key */
import React, { useContext, useEffect, useState } from 'react';
import { Modal, Button, Steps, message, Card, Row, Col, Typography, Descriptions, Divider, Form, Input, ConfigProvider } from 'antd';
import { DatePicker } from '@material-ui/pickers';
import { PlusOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import Step1PartiesPeriod from './steps/Step1PartiesPeriod';
import Step2TransactionSummary from './steps/Step2TransactionSummary';
import Step3FinancialAccounts from './steps/Step3FinancialAccounts';
import Step4BankTransfer from './steps/Step4BankTransfer';
import ReviewSettlement from './steps/ReviewSettlement';
import { settlementAPI } from '../../services/api';
import './SettlementWizard.css';
import { generateSettlementPDF, generateSettlementHTML } from '../../utils/pdfGenerator';
import moment from 'moment';
import { LanguageContext } from 'context/intl.context';

const { Step } = Steps;
const { Title, Text } = Typography;

// SettlementWizard
// Orchestrates a 5-step flow:
// 1) Parties & Period → 2) Transaction Summary → 3) Financial Accounts → 4) Bank Transfer → 5) Review
// Notes:
// - "Save as Draft" persists ONLY Step 1 fields using the unified upsert endpoint.
// - Confirmation performs an upsert with status=Confirmed, then shows a post-confirm modal (print/clear/reverse).
// - Validation to enable/disable navigation lives in getFooterButtons() for a consistent UX.
const SettlementWizard = ({ visible, onClose, onSuccess, initialData }) => {
  const intl = useIntl();

  // Helper function to translate status values
  const getTranslatedStatus = (status) => {
    const statusTranslations = {
      'Draft': intl.formatMessage({ id: 'settlement_StatusDraft' }),
      'Confirmed': intl.formatMessage({ id: 'settlement_StatusConfirmed' }),
      'Cleared': intl.formatMessage({ id: 'settlement_StatusCleared' }),
      'Reversed': intl.formatMessage({ id: 'settlement_StatusReversed' })
    };
    return statusTranslations[status] || status;
  };
  const { direction } = useContext(LanguageContext);
  // Display-only date formatter (keeps payload format unchanged)
  const fmt = (d) => {
    if (!d) return d;
    try {
      return moment(d).format('DD-MM-YYYY');
    } catch (_) {
      return d;
    }
  };
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [postConfirmVisible, setPostConfirmVisible] = useState(false);
  const [confirmedSettlement, setConfirmedSettlement] = useState(null);
  const [clearModalVisible, setClearModalVisible] = useState(false);
  const [reverseModalVisible, setReverseModalVisible] = useState(false);
  const [clearForm] = Form.useForm();
  const [reverseForm] = Form.useForm();

  // Get current language for RTL support
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const isArabic = currentLanguageCode === 'ar-eg';

  // Helper: strip null values so backend optional validators don't receive null (only undefined)
  const stripNulls = (obj) => {
    const cleaned = {};
    Object.keys(obj || {}).forEach((key) => {
      const val = obj[key];
      if (val !== null && val !== undefined) {
        cleaned[key] = val;
      }
    });

    return cleaned;
  };

  // Build Draft payload using ONLY Step 1 fields
  const buildDraftPayloadFromStep1 = () => {
    const normalizeDate = (d) => {
      if (!d) return d;
      // If already in YYYY-MM-DD format, keep as-is
      if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
      try {
        const dateObj = new Date(d);
        if (isNaN(dateObj.getTime())) return d; // leave as-is if unparsable
        const yyyy = dateObj.getFullYear();
        const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
        const dd = String(dateObj.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      } catch (_) {
        return d;
      }
    };
    const {
      settlement_type_id,
      sender_id,
      beneficiary_id,
      settlement_from_date,
      settlement_till_date,
      currency
    } = settlementData;
    return stripNulls({
      settlement_type_id,
      sender_id,
      beneficiary_id,
      settlement_from_date: normalizeDate(settlement_from_date),
      settlement_till_date: normalizeDate(settlement_till_date),
      currency,
      status: 'Draft'
    });
  };

  // Build the final payload to send to backend: strip nulls and only include selected channels
  const buildPayload = (data) => {
    const normalizeDate = (d) => {
      if (!d) return d;
      if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
      try {
        const dateObj = new Date(d);
        if (isNaN(dateObj.getTime())) return d;
        const yyyy = dateObj.getFullYear();
        const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
        const dd = String(dateObj.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      } catch (_) {
        return d;
      }
    };
    const filteredChannels = Array.isArray(data.channels)
      ? data.channels.filter((c) => c && c.included)
      : [];
    return stripNulls({
      ...data,
      channels: filteredChannels,
      settlement_from_date: normalizeDate(data.settlement_from_date),
      settlement_till_date: normalizeDate(data.settlement_till_date)
    });
  };
  // Single source of truth for wizard data (accumulated across steps)
  const [settlementData, setSettlementData] = useState({
    id: null,
    // Step 1: Parties & Period
    settlement_type_id: null,
    sender_id: null,
    beneficiary_id: null,
    settlement_from_date: null,
    settlement_till_date: null,
    currency: 'EGP',

    // Step 2: Transaction Summary (calculated)
    amount: 0,
    fees_amount: 0,
    tax_amount: 0,
    channels: [],

    // Step 3: Financial Accounts
    sender_debit_account_id: null,
    sender_credit_account_id: null,
    sender_income_account_id: null,
    sender_tax_liability_account_id: null,
    beneficiary_debit_account_id: null,
    beneficiary_credit_account_id: null,
    beneficiary_expense_account_id: null,
    beneficiary_tax_asset_account_id: null,

    // Step 4: Bank Transfer
    sender_bank_id: null,
    beneficiary_bank_id: null,
    notes: '',

    // Status
    status: 'Draft'
  });

  // Prefill when opened from external table (e.g., continuing a draft or viewing existing)
  useEffect(() => {
    if (visible) {
      if (initialData) {
        setCurrentStep(0);
        setSettlementData(prev => ({
          ...prev,
          id: initialData.id || prev.id,
          settlement_type_id: initialData.settlement_type_id ?? prev.settlement_type_id,
          sender_id: initialData.sender_id ?? prev.sender_id,
          beneficiary_id: initialData.beneficiary_id ?? prev.beneficiary_id,
          settlement_from_date: initialData.settlement_from_date ?? prev.settlement_from_date,
          settlement_till_date: initialData.settlement_till_date ?? prev.settlement_till_date,
          currency: initialData.currency || prev.currency,
          amount: initialData.amount ?? prev.amount,
          fees_amount: initialData.fees_amount ?? prev.fees_amount,
          tax_amount: initialData.tax_amount ?? prev.tax_amount,
          sender_bank_id: initialData.sender_bank_id ?? prev.sender_bank_id,
          beneficiary_bank_id: initialData.beneficiary_bank_id ?? prev.beneficiary_bank_id,
          notes: initialData.notes ?? prev.notes,
          status: initialData.status || prev.status
        }));
      }
    }
  }, [visible, initialData]);

  // Step registry: titles and their rendering components
  const steps = [
    {
      title: intl.formatMessage({ id: 'settlement_PartiesPeriod' }),
      content: intl.formatMessage({ id: 'settlement_SelectSenderBeneficiaryPeriod' }),
      component: Step1PartiesPeriod
    },
    {
      title: intl.formatMessage({ id: 'settlement_TransactionSummary' }),
      content: intl.formatMessage({ id: 'settlement_ReviewTransactionsSelectChannels' }),
      component: Step2TransactionSummary
    },
    {
      title: intl.formatMessage({ id: 'settlement_FinancialAccounts' }),
      content: intl.formatMessage({ id: 'settlement_MapAccountsForERP' }),
      component: Step3FinancialAccounts
    },
    {
      title: intl.formatMessage({ id: 'settlement_BankTransfer' }),
      content: intl.formatMessage({ id: 'settlement_SelectBankAccountsAddNotes' }),
      component: Step4BankTransfer
    },
    {
      title: intl.formatMessage({ id: 'settlement_Review' }),
      content: intl.formatMessage({ id: 'settlement_ReviewConfirmSettlement' }),
      component: ReviewSettlement
    }
  ];

  const persistDraft = async () => {
    // Persist ONLY Step 1 fields in Draft
    const payload = buildDraftPayloadFromStep1();
    try {
      // Keep log minimal to avoid console noise
      // console.debug('[Draft] Persist draft payload:', payload);
      message.loading({ content: intl.formatMessage({ id: 'settlement_SavingDraft' }), key: 'saveDraft', duration: 0 });
      setLoading(true);
      // Use unified upsert endpoint. Include settlement_id if we are updating an existing draft
      const upsertPayload = {
        ...payload,
        settlement_id: settlementData.id || undefined
      };
      const response = await settlementAPI.upsert(upsertPayload);
      // Backend returns data.settlementTransaction (JSONB)
      const returnedSettlement = response?.data?.data?.settlementTransaction;
      const newId = returnedSettlement?.id || response?.data?.data?.id || response?.data?.id;
      if (newId) {
        setSettlementData(prev => ({ ...prev, id: newId }));
      }
      message.success({ content: intl.formatMessage({ id: 'settlement_DraftSaved' }), key: 'saveDraft' });

      // Notify parent component to refresh the settlements table
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('[Draft] Save failed:', error);
      message.error({ content: intl.formatMessage({ id: 'settlement_FailedToSaveDraft' }) + ': ' + (error.response?.data?.message || error.message), key: 'saveDraft' });
      throw error;
    } finally {
      // Ensure any persistent loading toast is cleared
      message.destroy('saveDraft');
      setLoading(false);
    }
  };

  // Navigation: next step (no implicit persistence)
  const handleNext = async () => {
    // Navigate to the next step without persisting; user can explicitly save via Save as Draft
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Navigation: previous step
  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Validation function to check if a step is accessible
  const isStepAccessible = (targetStep) => {
    // Always allow going back to previous steps
    if (targetStep <= currentStep) {
      return true;
    }

    // Check if all previous steps are valid before allowing navigation to target step
    for (let i = 0; i < targetStep; i++) {
      if (!isStepValidForIndex(i)) {
        return false;
      }
    }

    return true;
  };

  // Helper function to validate a specific step by index
  const isStepValidForIndex = (stepIndex) => {
    if (stepIndex === 0) {
      const {
        settlement_type_id,
        sender_id,
        beneficiary_id,
        settlement_from_date,
        settlement_till_date
      } = settlementData;
      const isValid = (
        settlement_type_id != null &&
        sender_id != null &&
        beneficiary_id != null &&
        settlement_from_date != null &&
        settlement_till_date != null
      );
      // Additional rule: if step 1 says no settlement is needed, step is invalid
      const disableByNoNeed = settlementData?.is_need_to_settle === false;
      return isValid && !disableByNoNeed;
    }
    if (stepIndex === 1) {
      // Step 2: require at least one included channel AND a positive, valid amount to settle
      if (!Array.isArray(settlementData.channels)) return false;
      const hasIncluded = settlementData.channels.some((c) => c && c.included);
      const amt = Number(settlementData.amount);
      const validAmount = !Number.isNaN(amt) && amt > 0; // disable if 0, negative, or NaN
      return hasIncluded && validAmount;
    }
    if (stepIndex === 2) {
      // Step 3: require all financial account selections
      const {
        sender_debit_account_id,
        sender_credit_account_id,
        sender_income_account_id,
        sender_tax_liability_account_id,
        beneficiary_debit_account_id,
        beneficiary_credit_account_id,
        beneficiary_expense_account_id,
        beneficiary_tax_asset_account_id
      } = settlementData;
      return (
        sender_debit_account_id != null &&
        sender_credit_account_id != null &&
        sender_income_account_id != null &&
        sender_tax_liability_account_id != null &&
        beneficiary_debit_account_id != null &&
        beneficiary_credit_account_id != null &&
        beneficiary_expense_account_id != null &&
        beneficiary_tax_asset_account_id != null
      );
    }
    if (stepIndex === 3) {
      // Step 4: require both bank accounts selected
      const { sender_bank_id, beneficiary_bank_id } = settlementData;
      return sender_bank_id != null && beneficiary_bank_id != null;
    }
    return true;
  };

  // Direct step change via Steps component with validation
  const handleStepChange = (step) => {
    if (isStepAccessible(step)) {
      setCurrentStep(step);
    } else {
      // Show a message to user about completing previous steps
      message.warning(intl.formatMessage({ id: 'settlement_CompleteCurrentStepFirst' }));
    }
  };

  // Merge partial updates from child steps into the wizard state
  const updateSettlementData = (newData) => {
    setSettlementData(prev => {
      const updated = {
        ...prev,
        ...newData
      };
      return updated;
    });
  };

  // Save as Draft: persists only Step 1 fields. If later steps have data, confirm with user first.
  const handleSaveDraft = async () => {
    const hasStep2PlusData = (
      (Array.isArray(settlementData.channels) && settlementData.channels.length > 0) ||
      settlementData.sender_debit_account_id != null ||
      settlementData.sender_credit_account_id != null ||
      settlementData.sender_income_account_id != null ||
      settlementData.sender_tax_liability_account_id != null ||
      settlementData.beneficiary_debit_account_id != null ||
      settlementData.beneficiary_credit_account_id != null ||
      settlementData.beneficiary_expense_account_id != null ||
      settlementData.beneficiary_tax_asset_account_id != null ||
      settlementData.sender_bank_id != null ||
      settlementData.beneficiary_bank_id != null
    );

    if (hasStep2PlusData) {
      Modal.confirm({
        title: intl.formatMessage({ id: 'settlement_SaveDraftStep1Only' }),
        content: (
          <div>
            <p>{intl.formatMessage({ id: 'settlement_OnlyStep1WillBeSaved' })}</p>
            <p>{intl.formatMessage({ id: 'settlement_DataFromOtherStepsWillNotBeSaved' })}</p>
            <p>{intl.formatMessage({ id: 'settlement_DoYouWantToContinue' })}</p>
          </div>
        ),
        okText: intl.formatMessage({ id: 'settlement_SaveStep1Only' }),
        cancelText: intl.formatMessage({ id: 'cancel' }),
        onOk: async () => {
          try {
            await persistDraft();
            message.success(intl.formatMessage({ id: 'settlement_DraftSavedStep1Only' }));
          } catch (_) { }
        }
      });
      return;
    }

    try {
      await persistDraft();
      message.success(intl.formatMessage({ id: 'settlement_SettlementSavedAsDraft' }));
    } catch (_) { }
  };

  // Confirm & upsert settlement with status=Confirmed, then show post-confirmation actions
  const handleConfirmSettlement = () => {
    // Short helper to get short bank name (before " - ") from display text
    const getShortBank = (display) => {
      if (!display || typeof display !== 'string') return '—';
      const idx = display.indexOf(' - ');
      return idx > -1 ? display.slice(0, idx) : display;
    };

    const amountStr = Number(settlementData.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const senderName = settlementData.sender_name || intl.formatMessage({ id: 'settlement_SenderNotSelected' });
    const beneficiaryName = settlementData.beneficiary_name || intl.formatMessage({ id: 'settlement_BeneficiaryNotSelected' });
    const periodStr = `${fmt(settlementData.settlement_from_date)} – ${fmt(settlementData.settlement_till_date)}`;
    const senderBankShort = getShortBank(settlementData.sender_bank_display);
    const beneficiaryBankShort = getShortBank(settlementData.beneficiary_bank_display);

    Modal.confirm({
      title: intl.formatMessage({ id: 'settlement_ConfirmSettlement' }),
      content: (
        <div>
          <p>{intl.formatMessage({ id: 'settlement_YouAreAboutToCreate' })}</p>
          <ul>
            <li><strong>{intl.formatMessage({ id: 'settlement_Amount' })}:</strong> {amountStr} {intl.formatMessage({ id: 'settlement_EGP' })}</li>
            <li><strong>{intl.formatMessage({ id: 'settlement_From' })}:</strong> {senderName}</li>
            <li><strong>{intl.formatMessage({ id: 'settlement_To' })}:</strong> {beneficiaryName}</li>
            <li><strong>{intl.formatMessage({ id: 'settlement_Period' })}:</strong> {periodStr}</li>
            <li><strong>{intl.formatMessage({ id: 'settlement_BankTransfer' })}:</strong> {senderBankShort} → {beneficiaryBankShort}</li>
          </ul>
          <p style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
            {intl.formatMessage({ id: 'settlement_ThisActionCannotBeEdited' })}
          </p>
        </div>
      ),
      okText: intl.formatMessage({ id: 'settlement_ConfirmAndClose' }),
      cancelText: intl.formatMessage({ id: 'cancel' }),
      onOk: async () => {
        try {
          setLoading(true);
          // Validate mandatory bank IDs before sending
          if (!settlementData.sender_bank_id || !settlementData.beneficiary_bank_id) {
            message.error(intl.formatMessage({ id: 'settlement_BankAccountsMustBeSelected' }));
            return Promise.reject();
          }

          const finalData = { ...settlementData, status: 'Confirmed' };
          const payload = buildPayload(finalData);
          const upsertPayload = {
            ...payload,
            settlement_id: finalData.id || undefined
          };
          const response = await settlementAPI.upsert(upsertPayload);
          const returnedSettlement = response?.data?.data?.settlementTransaction;
          const newId = returnedSettlement?.id || response?.data?.data?.id || response?.data?.id;
          if (newId) {
            setSettlementData(prev => ({ ...prev, id: newId }));
          }

          message.success(intl.formatMessage({ id: 'settlement_CreatedAndConfirmedSuccessfully' }));
          // Keep wizard open and show Post-Confirmation modal
          // Use server response data to ensure all database fields are included
          const snapshot = {
            ...finalData,
            ...returnedSettlement, // Include all server response fields (created_at, reversed_at, etc.)
            id: newId || finalData.id,
            status: 'Confirmed'
          };
          setConfirmedSettlement(snapshot);
          setPostConfirmVisible(true);
          onSuccess?.(response?.data);
        } catch (error) {
          message.error(intl.formatMessage({ id: 'settlement_FailedToCreate' }) + ': ' + (error.response?.data?.message || error.message));
          return Promise.reject(error);
        } finally {
          setLoading(false);
        }
      }
    });
  };

  // Reset state to initial values when closing/resetting the wizard
  const resetWizard = () => {
    setCurrentStep(0);
    setSettlementData({
      id: null,
      settlement_type_id: null,
      sender_id: null,
      beneficiary_id: null,
      settlement_from_date: null,
      settlement_till_date: null,
      currency: 'EGP',
      amount: 0,
      fees_amount: 0,
      tax_amount: 0,
      channels: [],
      sender_debit_account_id: null,
      sender_credit_account_id: null,
      sender_income_account_id: null,
      sender_tax_liability_account_id: null,
      beneficiary_debit_account_id: null,
      beneficiary_credit_account_id: null,
      beneficiary_expense_account_id: null,
      beneficiary_tax_asset_account_id: null,
      sender_bank_id: null,
      beneficiary_bank_id: null,
      notes: '',
      status: 'Draft'
    });
  };

  const handleClose = () => {
    resetWizard();
    onClose();
  };

  // Handle closing the post-confirmation modal (same action for X button and Close button)
  const handlePostConfirmClose = () => {
    setPostConfirmVisible(false);
    resetWizard();
    onClose();
    if (onSuccess) onSuccess();
  };

  // Renderer: current step component with shared props
  const getCurrentStepComponent = () => {
    const StepComponent = steps[currentStep].component;
    return (
      <StepComponent
        data={settlementData}
        onDataChange={updateSettlementData}
        onNext={handleNext}
        onPrev={handlePrev}
        isLastStep={currentStep === steps.length - 1}
        onConfirm={handleConfirmSettlement}
        loading={loading}
      />
    );
  };

  // Footer actions: context-aware Back/Save/Next/Confirm with minimal validation gates
  const getFooterButtons = () => {
    const buttons = [];
    const isStepValid = () => {
      // Step-specific simple validation to disable actions when required fields are null/undefined
      if (currentStep === 0) {
        const {
          settlement_type_id,
          sender_id,
          beneficiary_id,
          settlement_from_date,
          settlement_till_date
        } = settlementData;
        return (
          settlement_type_id != null &&
          sender_id != null &&
          beneficiary_id != null &&
          settlement_from_date != null &&
          settlement_till_date != null
        );
      }
      if (currentStep === 1) {
        // Step 2: require at least one included channel AND a positive, valid amount to settle
        if (!Array.isArray(settlementData.channels)) return false;
        const hasIncluded = settlementData.channels.some((c) => c && c.included);
        const amt = Number(settlementData.amount);
        const validAmount = !Number.isNaN(amt) && amt > 0; // disable if 0, negative, or NaN
        return hasIncluded && validAmount;
      }
      if (currentStep === 2) {
        // Step 3: require all financial account selections
        const {
          sender_debit_account_id,
          sender_credit_account_id,
          sender_income_account_id,
          sender_tax_liability_account_id,
          beneficiary_debit_account_id,
          beneficiary_credit_account_id,
          beneficiary_expense_account_id,
          beneficiary_tax_asset_account_id
        } = settlementData;
        return (
          sender_debit_account_id != null &&
          sender_credit_account_id != null &&
          sender_income_account_id != null &&
          sender_tax_liability_account_id != null &&
          beneficiary_debit_account_id != null &&
          beneficiary_credit_account_id != null &&
          beneficiary_expense_account_id != null &&
          beneficiary_tax_asset_account_id != null
        );
      }
      if (currentStep === 3) {
        // Step 4: require both bank accounts selected
        const { sender_bank_id, beneficiary_bank_id } = settlementData;
        return sender_bank_id != null && beneficiary_bank_id != null;
      }
      return true;
    };

    const disableActions = !isStepValid();
    // Additional rule: if step 1 says no settlement is needed, disable actions regardless
    const disableByNoNeed = currentStep === 0 && settlementData?.is_need_to_settle === false;

    // Back button (not on first step)
    if (currentStep > 0) {
      buttons.push(
        <Button key="back" onClick={handlePrev}>
          {intl.formatMessage({ id: 'settlement_Back' })}
        </Button>
      );
    }

    // Save as Draft button (only on first step)
    if (currentStep === 0) {
      buttons.push(
        <Button key="draft" onClick={handleSaveDraft} loading={loading} disabled={disableActions || disableByNoNeed}>
          {intl.formatMessage({ id: 'settlement_SaveAsDraft' })}
        </Button>
      );
    }

    // Next/Review button (not on last step)
    if (currentStep < steps.length - 1) {
      buttons.push(
        <Button key="next" type="primary" onClick={handleNext} disabled={disableActions || disableByNoNeed}>
          {currentStep === steps.length - 2 ? intl.formatMessage({ id: 'settlement_ReviewSettlement' }) : intl.formatMessage({ id: 'settlement_Next' })}
        </Button>
      );
    }

    // Confirm button (only on review step)
    if (currentStep === steps.length - 1) {
      buttons.push(
        <Button key="confirm" type="primary" onClick={handleConfirmSettlement} loading={loading}>
          {intl.formatMessage({ id: 'settlement_ConfirmSettlement' })}
        </Button>
      );
    }

    return buttons;
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'settlement_AddSettlementTransaction' })}
      open={visible}
      onCancel={handleClose}
      width={900}
      footer={getFooterButtons()}
      className="settlement-wizard-modal"
      destroyOnClose
    >
      <ConfigProvider componentSize="small" direction={direction}>
        <div className="settlement-wizard" dir={direction}>
          <Steps
            current={currentStep}
            onChange={handleStepChange}
            className="settlement-steps"
            size="small"
          >
            {steps.map((step, index) => (
              <Step
                key={index}
                title={step.title}
                description={step.content}
              />
            ))}
          </Steps>

          <div className="settlement-step-content">
            {getCurrentStepComponent()}
          </div>
        </div>
      </ConfigProvider>

      {/* Post-Confirmation Modal: print, clear, reverse, and close */}
      <Modal
        title={intl.formatMessage({ id: 'settlement_PostConfirmationViewSettlement' })}
        open={postConfirmVisible}
        onCancel={handlePostConfirmClose}
        footer={null}
      >
        {confirmedSettlement && (
          <div>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Title level={5} style={{ marginBottom: 0 }}>
                  {confirmedSettlement.id || 'S12345'}
                </Title>
                <Text>{intl.formatMessage({ id: 'settlement_Status' })}: {getTranslatedStatus(confirmedSettlement.status)}</Text>
              </Col>
            </Row>

            <Divider />

            <Row gutter={[16, 16]}>
              <Col xs={24} md={12}>
                <Descriptions column={1} bordered size="small">
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_BeneficiaryPTO' })}>
                    {confirmedSettlement.beneficiary_name || intl.formatMessage({ id: 'settlement_DefaultBeneficiaryName' })}
                  </Descriptions.Item>
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_PeriodLabel' })}>
                    {fmt(confirmedSettlement.settlement_from_date)} – {fmt(confirmedSettlement.settlement_till_date)}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
              <Col xs={24} md={12}>
                <Descriptions title="" column={1} bordered size="small">
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Amount' })}>
                    {Number(confirmedSettlement.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} EGP
                  </Descriptions.Item>
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_Fees' })}>
                    {Number(confirmedSettlement.summed_fees || confirmedSettlement.fees_amount || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 })} EGP
                  </Descriptions.Item>
                  <Descriptions.Item label={intl.formatMessage({ id: 'settlement_VAT' })}>
                    {Number(confirmedSettlement.summed_vat || confirmedSettlement.tax_amount || 0).toLocaleString('en-US', { minimumFractionDigits: 5, maximumFractionDigits: 5 })} EGP
                  </Descriptions.Item>
                </Descriptions>
              </Col>
            </Row>

            <Divider />

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <Button
                onClick={async () => {
                  try {
                    const data = confirmedSettlement;
                    // Compute ERP journal suggestion for PDF using summed values
                    const amt = Math.abs(Number(data.amount) || 0);
                    const fees = Number(data.summed_fees || data.fees_amount) || 0;
                    const vat = Number(data.summed_vat || data.tax_amount) || 0;
                    const totalDebit = amt + fees + vat;
                    const journalEntries = [
                      {
                        account: 'Unsettled Dues',
                        debit: totalDebit,
                        credit: 0,
                        description: intl.formatMessage({ id: 'settlement_ClearUnsettledDuesLiability' })
                      },
                      {
                        account: 'Bank Account',
                        debit: 0,
                        credit: amt,
                        description: intl.formatMessage({ id: 'settlement_NetCashTransferredToPTO' })
                      },
                      {
                        account: 'VAT Payable',
                        debit: 0,
                        credit: vat,
                        description: intl.formatMessage({ id: 'settlement_VATOnFeesTotal' })
                      },
                      {
                        account: 'Commission Income',
                        debit: 0,
                        credit: fees,
                        description: intl.formatMessage({ id: 'settlement_TotalFeesEarnedSummed' })
                      }
                    ];
                    // Beneficiary journal entries (PTO)
                    const beneficiaryJournalEntries = [
                      {
                        account: 'Operating Account (10100)',
                        debit: amt,
                        credit: 0,
                        description: intl.formatMessage({ id: 'settlement_NetCashReceivedFromSender' })
                      },
                      {
                        account: 'Commission Expense (50100)',
                        debit: fees,
                        credit: 0,
                        description: intl.formatMessage({ id: 'settlement_CommissionExpenseTotal' })
                      },
                      {
                        account: 'VAT Receivable (10200)',
                        debit: vat,
                        credit: 0,
                        description: intl.formatMessage({ id: 'settlement_VATOnCommissionTotal' })
                      },
                      {
                        account: 'Fare Revenue (40100)',
                        debit: 0,
                        credit: totalDebit,
                        description: intl.formatMessage({ id: 'settlement_RecognizeFareRevenue' })
                      }
                    ];

                    const pdfPayload = {
                      id: settlementData.id,
                      sender: settlementData.sender_name || '',
                      beneficiary: settlementData.beneficiary_name || '',
                      fromDate: settlementData.settlement_from_date || '',
                      toDate: settlementData.settlement_till_date || '',
                      currency: settlementData.currency || 'EGP',
                      amount: settlementData.amount || 0,
                      status: confirmedSettlement.status || settlementData.status || 'Draft',
                      senderBank: settlementData.sender_bank_display || '',
                      beneficiaryBank: settlementData.beneficiary_bank_display || '',
                      senderBankName: settlementData.sender_bank_name || '',
                      beneficiaryBankName: settlementData.beneficiary_bank_name || '',
                      bank_ref_no: confirmedSettlement.bank_ref_no || settlementData.bank_ref_no || '',
                      bank_description: confirmedSettlement.bank_description || settlementData.bank_description || '',
                      bank_transfer_date: confirmedSettlement.bank_transfer_date || settlementData.bank_transfer_date || '',
                      notes: settlementData.notes || '',
                      // Add missing fields from database
                      reversal_reason: confirmedSettlement.reversal_reason || settlementData.reversal_reason || '',
                      reversed_at: confirmedSettlement.reversed_at || settlementData.reversed_at || '',
                      reversed_by: confirmedSettlement.reversed_by || settlementData.reversed_by || '',
                      created_at: confirmedSettlement.created_at || settlementData.created_at || '',
                      senderJournalEntries: journalEntries,
                      beneficiaryJournalEntries: beneficiaryJournalEntries
                    };

                    // Store data in sessionStorage for the new tab
                    sessionStorage.setItem('settlementPDFData', JSON.stringify(pdfPayload));

                    // Open PDF preview in new tab
                    const newTab = window.open('/settlements/settlementTransactions/pdf-preview', '_blank');
                    if (!newTab) {
                      message.error(intl.formatMessage({ id: 'settlement_PleaseAllowPopups' }));
                    } else {
                      message.success(intl.formatMessage({ id: 'settlement_PDFPreviewOpened' }));
                    }
                  } catch (err) {
                    console.error('Error opening PDF preview:', err);
                    message.error(intl.formatMessage({ id: 'settlement_FailedToOpenPDFPreview' }));
                  }
                }}
              >
                {intl.formatMessage({ id: 'settlement_PrintSettlement' })}
              </Button>
              {confirmedSettlement.status === 'Confirmed' && (
                <>
                  <Button
                    danger
                    onClick={() => setClearModalVisible(true)}
                  >
                    {intl.formatMessage({ id: 'settlement_ClearSettlement' })}
                  </Button>
                  <Button
                    danger
                    onClick={() => setReverseModalVisible(true)}
                  >
                    {intl.formatMessage({ id: 'settlement_Reverse' })}
                  </Button>
                </>
              )}

              {confirmedSettlement.status === 'Cleared' && (
                <Text type="success" strong>
                  {intl.formatMessage({ id: 'settlement_SettlementHasBeenCleared' })}
                </Text>
              )}
            </div>

            <div style={{ marginTop: 16, textAlign: 'right' }}>
              <Button onClick={handlePostConfirmClose}>
                {intl.formatMessage({ id: 'settlement_Close' })}
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {/* Clear Settlement Modal */}
      <Modal
        title={intl.formatMessage({ id: 'settlement_ClearSettlement' })}
        open={clearModalVisible}
        onCancel={() => setClearModalVisible(false)}
        okText={intl.formatMessage({ id: 'settlement_MarkAsCleared' })}
        cancelText={intl.formatMessage({ id: 'cancel' })}
        onOk={() => clearForm.submit()}
        confirmLoading={loading}
        style={{ direction: isArabic ? 'rtl' : 'ltr' }}
      >
        <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
          <Form
            layout="vertical"
            form={clearForm}
            onFinish={async (values) => {
              try {
                setLoading(true);
                const id = confirmedSettlement?.id;
                if (!id) throw new Error(intl.formatMessage({ id: 'settlement_MissingSettlementID' }));
                const payload = {
                  bank_ref_no: values.bank_ref_no,
                  bank_description: values.bank_description || intl.formatMessage({ id: 'settlement_NoDescriptionEntered' }),
                  bank_transfer_date: values.bank_transfer_date?.format ? values.bank_transfer_date.format('YYYY-MM-DD') : values.bank_transfer_date
                };
                const response = await settlementAPI.clear(id, payload);
                // Use server response data to ensure all database fields are included (cleared_at, cleared_by, etc.)
                const clearedSettlement = response?.data?.data?.settlementTransaction || response?.data?.data || response?.data;
                setConfirmedSettlement(prev => ({
                  ...prev,
                  ...clearedSettlement, // Include all server response fields
                  status: 'Cleared'
                }));
                message.success(intl.formatMessage({ id: 'settlement_MarkedAsCleared' }));
                setClearModalVisible(false);
                clearForm.resetFields();

                // Notify parent component to refresh the settlements table
                if (onSuccess) {
                  onSuccess();
                }
              } catch (e) {
                message.error(intl.formatMessage({ id: 'settlement_FailedToClear' }));
              } finally {
                setLoading(false);
              }
            }}
          >
            <Form.Item
              label={intl.formatMessage({ id: 'settlement_ACHReferenceNo' })}
              name="bank_ref_no"
              rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterACHRef' }) }]}
            >
              <Input placeholder={intl.formatMessage({ id: 'settlement_EnterBankRefNumber' })} />
            </Form.Item>

            <Form.Item
              label={intl.formatMessage({ id: 'settlement_Description' })}
              name="bank_description"
              initialValue={intl.formatMessage({ id: 'settlement_NoDescriptionEntered' })}
              rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterDescription' }) }]}
            >
              <Input placeholder={intl.formatMessage({ id: 'settlement_DescriptionPlaceholder' })} />
            </Form.Item>

            <Form.Item
              label={intl.formatMessage({ id: 'settlement_TransferDate' })}
              name="bank_transfer_date"
              initialValue={moment()}
              rules={[
                { required: true, message: intl.formatMessage({ id: 'settlement_PleaseSelectTransferDate' }) },
                {
                  validator: (_, value) => {
                    if (value && moment(value).isAfter(moment(), 'day')) {
                      return Promise.reject(new Error(intl.formatMessage({ id: 'settlement_TransferDateCannotBeFuture' })));
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <DatePicker
                variant="inline"
                inputVariant="outlined"
                format="DD-MM-yyyy"
                style={{ width: '100%', height: '35px' }}
                InputProps={{ style: { height: '35px' } }}
                maxDate={moment()}
                value={clearForm.getFieldValue('bank_transfer_date') || moment()}
                onChange={(date) => {
                  clearForm.setFieldsValue({ bank_transfer_date: date });
                  clearForm.validateFields(['bank_transfer_date']);
                }}
              />
            </Form.Item>
          </Form>
        </div>
      </Modal>

      {/* Reverse Settlement Modal */}
      <Modal
        title={intl.formatMessage({ id: 'settlement_ReverseSettlement' })}
        open={reverseModalVisible}
        onCancel={() => setReverseModalVisible(false)}
        okText={intl.formatMessage({ id: 'settlement_Reverse' })}
        cancelText={intl.formatMessage({ id: 'cancel' })}
        onOk={() => reverseForm.submit()}
        confirmLoading={loading}
        style={{ direction: isArabic ? 'rtl' : 'ltr' }}
      >
        <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
          <Form
            layout="vertical"
            form={reverseForm}
            onFinish={async (values) => {
              try {
                setLoading(true);
                const id = confirmedSettlement?.id;
                if (!id) throw new Error(intl.formatMessage({ id: 'settlement_MissingSettlementID' }));
                const payload = { reversal_reason: values.reversal_reason };
                const response = await settlementAPI.reverse(id, payload);
                // Use server response data to ensure all database fields are included (reversed_at, reversed_by, etc.)
                const reversedSettlement = response?.data?.data?.settlementTransaction || response?.data?.data || response?.data;
                setConfirmedSettlement(prev => ({
                  ...prev,
                  ...reversedSettlement, // Include all server response fields
                  status: 'Reversed'
                }));
                message.success(intl.formatMessage({ id: 'settlement_ReversedSuccessfully' }));
                setReverseModalVisible(false);
                reverseForm.resetFields();

                // Notify parent component to refresh the settlements table
                if (onSuccess) {
                  onSuccess();
                }
              } catch (e) {
                message.error(intl.formatMessage({ id: 'settlement_FailedToReverse' }));
              } finally {
                setLoading(false);
              }
            }}
          >
            <Form.Item
              label={intl.formatMessage({ id: 'settlement_ReversalReason' })}
              name="reversal_reason"
              rules={[{ required: true, message: intl.formatMessage({ id: 'settlement_PleaseEnterReversalReason' }) }]}
            >
              <Input.TextArea rows={3} placeholder={intl.formatMessage({ id: 'settlement_EnterReasonForReversal' })} />
            </Form.Item>
          </Form>
        </div>
      </Modal>

    </Modal>
  );
};

// Main Settlement Button Component
export const SettlementButton = ({ onSuccess }) => {
  const intl = useIntl();
  const [wizardVisible, setWizardVisible] = useState(false);

  return (
    <>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setWizardVisible(true)}
        size="large"
        className="settlement-create-button"
      >
        {intl.formatMessage({ id: 'settlement_NewSettlement' })}
      </Button>

      <SettlementWizard
        visible={wizardVisible}
        onClose={() => setWizardVisible(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default SettlementWizard;
